<template>

  <v-container fluid v-if="roles">

    <im-page-title
      title="Roluri"
    />

    <im-role-tool
      :query.sync="query"
      @create="goToCreate"
    />

    <div class="ma-3">
      <v-progress-linear
        :indeterminate="querying"
        :color="querying ? 'primary' : 'grey'"
        rounded
      />
    </div>

    <im-role-list
      :roles="roles"
      :pagination.sync="pagination"
      @edit="goToEdit"
    />

  </v-container>

  <v-container v-else fluid class="fill-height">
    <v-row align="center" justify="center">
      <v-progress-circular indeterminate color="primary"/>
    </v-row>
  </v-container>

</template>

<script>

  import roles_repository from '@/repositories/roles-repository'

  export default {

    components: {
      'im-page-title': () => import('@/components/ThePageTitle'),
      'im-role-tool': () => import('@/components/Admin/Role/RoleToolbar'),
      'im-role-list': () => import('@/components/Admin/Role/RoleList')
    },

    data: () => ({
      roles: null,
      query: null,
      querying: false,
      pagination: {size: 10, page: 1}
    }),

    watch: {
      query: {
        handler: 'fetchRolesDebounced',
        immediate: true
      },
      pagination: {
        handler: 'fetchRoles',
        immediate: false
      }
    },

    methods: {

      fetchRolesDebounced: _.debounce(function () {
        this.pagination.page = 1;
        this.fetchRoles()
      }, 300),

      async fetchRoles() {
        try {
          this.querying = true;
          this.roles = await roles_repository.getRoles(null, this.pagination, {});
        } catch (e) {
          await this.$store.dispatch('alert/error', e);
        } finally {
          this.querying = false;
        }
      },

      goToCreate() {
        this.$router.push(`/admin/roles/create`);
      },

      goToEdit(role) {
        this.$router.push(`/admin/roles/${role.id}`);
      }

    }

  }
</script>